import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_BASE_URL } from '../config';

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Only force logout on real auth failures (expired/invalid token).
    // Do NOT logout on network blips, timeouts, or temporary backend unavailability —
    // those are common while processing data and were causing random auto-logouts.
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Don't clear session on failed login attempts
      if (!url.includes('/auth/login')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }

    if (
      error.code === 'ERR_NETWORK' ||
      error.code === 'ERR_CONNECTION_REFUSED' ||
      error.message === 'Network Error'
    ) {
      console.error('Network error - backend temporarily unreachable (session kept)');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
